import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Archive';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25 11.25C7.83578 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.83578 12.75 8.25 12.75H15.75C16.1642 12.75 16.5 12.4142 16.5 12C16.5 11.5858 16.1642 11.25 15.75 11.25H8.25Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V8.25C21 8.66421 20.6642 9 20.25 9H19.5V20.25C19.5 20.6642 19.1642 21 18.75 21H5.24999C4.83578 21 4.49999 20.6642 4.49999 20.25V9H3.75C3.33579 9 3 8.66421 3 8.25V3.75ZM5.99999 9H18V19.5H5.99999V9ZM19.5 7.5H4.5V4.5H19.5V7.5Z" fill="currentColor"/>
  </svg>
`;

const ArchiveIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M8.25 11.25C7.83578 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.83578 12.75 8.25 12.75H15.75C16.1642 12.75 16.5 12.4142 16.5 12C16.5 11.5858 16.1642 11.25 15.75 11.25H8.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V8.25C21 8.66421 20.6642 9 20.25 9H19.5V20.25C19.5 20.6642 19.1642 21 18.75 21H5.24999C4.83578 21 4.49999 20.6642 4.49999 20.25V9H3.75C3.33579 9 3 8.66421 3 8.25V3.75ZM5.99999 9H18V19.5H5.99999V9ZM19.5 7.5H4.5V4.5H19.5V7.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: ArchiveIcon,
  IconSvg: IconSvg
} as IconType;
